import { computed, unref, watch } from 'vue';
import type { ComponentRef } from '@mts-fe/types';
import type { ComputedRef, Ref } from 'vue';
import { isNil } from '@mts-fe/utils';
import { createSortable } from '@mts/hooks/web/useSortable';
import type { BasicTableProps } from '../..';

export const useTableSortable = (
  propsRef: ComputedRef<BasicTableProps>,
  tableElRef: Ref<ComponentRef>,
  getDataSourceRef: ComputedRef<Recordable[]>,
  exchangeTableData: (oldIndex: number, newIndex: number) => Recordable[],
) => {
  const canSortable = computed(
    () => unref(propsRef).sortable && !!unref(getDataSourceRef).length && !!unref(tableElRef),
  );

  watch(
    () => canSortable.value,
    (val, prevVal) => val && !prevVal && initSortable(),
    { flush: 'post' },
  );

  const initSortable = () => {
    const el = tableElRef.value?.$el.querySelector<HTMLElement>('tbody.ant-table-tbody');
    if (!el) return;

    const { onTableDataChanged, ...sortableOptions } = unref(propsRef).sortableOptions || {};
    createSortable(el, {
      handle: '.ant-table-row',
      ignore: '.ant-table-measure-row',
      ...sortableOptions,
      onEnd: ({ oldIndex, newIndex }) => {
        if (isNil(oldIndex) || isNil(newIndex) || oldIndex === newIndex) {
          return;
        }

        const dataSource = exchangeTableData(oldIndex - 1, newIndex - 1);
        onTableDataChanged?.(dataSource);
      },
    });
  };
};
